<section class="margin-start col-8 col-md-12">
    <div class="d-flex justify-content-center align-items-center flex-column h-100vh">
        <img loading="lazy"  src="../../../assets//icons/404-Error.svg" class="img-mb img-dim" />
        <h1 class="font-bold font-big mb-4">Oops! We Can’t Find That Page</h1>
        <p class="text-wrap font-md"> We encountered an error while trying to access the page. Can you try again?
        </p>
    </div>
</section>